'use strict';

const { h } = require('phy');

function OfferFinancialTerms({ terms, className }) {
  const termsList = terms.sort(({ order: a }, { order: b }) =>
    a === b ? 0 : a > b ? 1 : -1
  );

  const { term: title } = termsList.shift() || {};

  return (
    termsList.length > 0 &&
    h(`.${className}`, [
      h(`p.${className}-title`, title),
      h(
        `ul.${className}-list`,
        termsList.map(({ term }) => h(`li.${className}-item`, term))
      ),
    ])
  );
}

module.exports = OfferFinancialTerms;
